import type {AuthenticatedUser} from "auth/types";
import {createPatchHook, createPostHook} from "services/http/hooks";

type RegisterPayload = {
  company_name: string;
  full_name: string;
  phone: string;
  email: string;
  password: string;
};

export const useLogInMutation = createPostHook<
  AuthenticatedUser,
  {email: string; password: string}
>("/auth/login");

export const useRegisterMutation = createPostHook<
  AuthenticatedUser,
  RegisterPayload
>("/auth/register");

export const usePasswordResetMutation = createPatchHook<
  AuthenticatedUser,
  {password: string; new_password: string}
>("/auth/password");

export const useSendResetCodeMutation = createPostHook<
  undefined,
  {email: string}
>("/auth/reset-code");

export const useForgotPasswordResetMutation = createPostHook<
  undefined,
  {email: string; code: string; password: string}
>("/auth/reset-password");
